<template>
  <div>
    <!--begin::Content header-->
    <div style="display:none"
      class="position-absolute top-0 right-0 text-right mt-5 mb-15 mb-lg-0 flex-column-auto justify-content-center py-5 px-10"
    >
      <span class="font-weight-bold font-size-3 text-dark-60">
        ¿Aún no tienes una cuenta?
      </span>
      <router-link
        class="font-weight-bold font-size-3 ml-2"
        :to="{ name: 'register' }"
      >
      !Regístrate!
      </router-link>
    </div>
    <!--end::Content header-->
      <!--begin::Form-->
      <b-form class="form-signin d-flex align-items-stretch flex-column" @submit.stop.prevent="onSubmit">
        <div class="text-center mb-2">
          <img class="mb-2" src="media/img/femsa.png" alt="" width="120">
          <h3 class="mb-0">Registro como nuevo usuario</h3>
        <span></span>
        </div>

        <div
          role="alert" v-bind:class="{ show: errors.length }"
          class="alert alert-success"
        >
          <div class="alert-text">
            Su cuenta ha sido creada de forma exitosa.
          </div>
        </div>
        <p class="mt-3 mb-3 text-muted text-center">
          <router-link
            class="text-dark-60 text-hover-primary my-3 mr-2"
            :to="{name:'login'}"
            id="kt_login_forgot"
          >
           Volver
          </router-link>
        </p>
        <!--end::Action-->
      </b-form>
      <!--end::Form-->
    
  </div>
</template>

<style lang="scss" scoped>
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>

<script>
import { mapState } from "vuex";
import {rutEsValido} from "@/core/validators/rut.js"
import { validationMixin } from "vuelidate";
import { email, minLength, required } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  name: "register",
  data() {
    return {
      step2:false,
      // Remove this dummy login info
      form: {
        rutEmpresa: "",//"96776000-5",
        rutCliente:"",
        numeroDocumento: "",
        nombres:"",
        apellidos:"",
        email:""
      },
      formFull: {
        rutEmpresa: "",//"96776000-5",
        rutCliente:"",
        numeroDocumento: "",
        nombres:"",
        apellidos:"",
        email:""
      }
    };
  },
  validations: {
    form: {
      rutEmpresa: {
        required,
       rutEsValido
      },
      numeroDocumento: {
        required,
        minLength: minLength(3)
      }
    },
    formFull: {
      
      rutCliente: {
        required,
        rutEsValido
      },
      nombres: {
        required,
        minLength: minLength(3)
      },
      apellidos: {
        required,
        minLength: minLength(3)
      },
      email: {
        required,
        email
      }
    }
  },
  methods: {
    makeToast(append = false) {
      this.$bvToast.toast(`Hemos validado correctamente la información.
          Ahora completa tu nombre, apellido y email para darte de alta.`, {
        title: 'Te hemos validado',
        autoHideDelay: 5000,
        variant: "success",
        toaster:"b-toaster-top-right",
        appendToast: append
      })
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    validateStateFull(name) {
      const { $dirty, $error } = this.$v.formFull[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        rutEmpresa: null,
        rutCliente:null,
        numeroDocumento: null,
        nombres:null,
        apellidos:null,
        email:null
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit() {
      console.log('step2 '  + this.step2);
      if(!this.step2){
        this.$v.form.$touch();
        if (this.$v.form.$anyError) {
          return;
        }
        this.verificaCuenta();
      } else {
        this.$v.formFull.$touch();
        if (this.$v.formFull.$anyError) {
          return;
        }
        
        this.crearCuenta();
      }
    },
    verificaCuenta(){
     
    },
    crearCuenta(){
      
    }

  },
  computed: {
    ...mapState({
      errors: state => state.account.errors
    })
  }
};
</script>
<style scoped>
.messaging {font-size: 0.8em;}
.alert-success {
    color: #155724 !important;
    background-color: #d4edda;
    border-color: #c3e6cb;
}
</style>